import { render, staticRenderFns } from "./CheckoutUserCart.vue?vue&type=template&id=2863ba1a"
import script from "./CheckoutUserCart.vue?vue&type=script&lang=js"
export * from "./CheckoutUserCart.vue?vue&type=script&lang=js"
import style0 from "./CheckoutUserCart.vue?vue&type=style&index=0&id=2863ba1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports